import { Utilities as utilities } from '@truckdown/framework';
import { LogEntryEventIdModel } from './LogEntryEventIdModel';
import { LogEntryExceptionModel } from './LogEntryExceptionModel';
import { LogLevel } from './LogLevel';

class KeyValuePair {
    key: string = '';
    value: string = '';
}

export class LogEntryModel {
    constructor(json?: any) {
        if (json) {
            this.id = utilities.json.getStringValue(json, '_id', '');
            this.timeStamp = utilities.json.getDateValue(json, 't', new Date(0));

            if (json.hasOwnProperty('eid') && json['eid'] && json['eid'] !== null) {
                let eid = new LogEntryEventIdModel();
                eid.id = utilities.json.getNumberValue(json['eid'], 'id', 0);
                eid.name = utilities.json.getStringValue(json['eid'], 'n', '');
                this.eventId = eid;
            }

            this.level = utilities.json.getEnumValue<LogLevel>(json, 'l', LogLevel, LogLevel.Information);
            this.category = utilities.json.getStringValue(json, 'c', '');
            this.message = utilities.json.getStringValue(json, 'msg', '');
            this.instance = utilities.json.getStringValue(json, 'inst', '');
            this.contextId = utilities.json.getStringValue(json, 'contextId', '');
            this.userId = utilities.json.getStringValue(json, 'uid');

            if (json.hasOwnProperty('ex') && json['ex'] && json['ex'] !== null) {
                this.exception = new LogEntryExceptionModel(json['ex']);
            }
            this.properties = utilities.json.getArrayValue<KeyValuePair>(json, (dt) => {
                return dt as KeyValuePair;
            }, 'props', []);
        }
    }

    id: string = '';
    timeStamp: Date = new Date(0);
    eventId: LogEntryEventIdModel | null = null;
    level: LogLevel = LogLevel.Information;
    category: string = '';
    message: string = '';
    instance: string = '';
    contextId: string = '';
    userId: string | null = null;
    exception: LogEntryExceptionModel | null = null;
    properties: KeyValuePair[] = [];
}